import { render, staticRenderFns } from "./CorrelationContent.vue?vue&type=template&id=2444d386&scoped=true"
import script from "./CorrelationContent.vue?vue&type=script&lang=ts"
export * from "./CorrelationContent.vue?vue&type=script&lang=ts"
import style0 from "./CorrelationContent.vue?vue&type=style&index=0&id=2444d386&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2444d386",
  null
  
)

export default component.exports